<template>
  <div class="w-100">
    <b-row class="w-100 no-print">
      <div
        v-for="(page, n) in pages"
        :key="n"
        v-if="checkIsHeaderGroup(page.slug)"
        style="width: 12%"
        class="mx-1"
      >
        <router-link :to="page.path">
          <!-- v-if="checkIsHeaderGroup(page)" -->
          <div
            style="display: flex; flex-direction: column; text-align: center"
            class="tab-cont shadow"
          >
            <div class="my-50">
              <feather-icon size="25" :icon="page.icon"> </feather-icon>
            </div>
            <span class="font-weight-bold">{{ page.label }}</span>
          </div>
        </router-link>
      </div>
    </b-row>
    <div class="mt-2">
      <transition name="zoom-fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>
<script>
import AuthHelpers from "@/utils/auth-helpers";
import {
  BTabs,
  BTab,
  BButton,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import { mapActions } from "vuex";
export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BCardBody,
    BButton,
    BRow,
    BCol,
    BCard,
    BCardBody,
  },
  // ...
  data() {
    return {
      // Store the value in data before we update the value so later we can restore the same value when user leaves the page
      menuHidden: this.$store.state.appConfig.layout.menu.hidden,
      pages: [
        {
          path: "/ministry/dashboard",
          label: "لوحة التحكم",
          icon: "HomeIcon",
          slug: ["ministry_dashboard"],
        },
        {
          path: "/ministry/ngos",
          label: "البحث عن منظمة",
          icon: "SearchIcon",
          slug: ["ministry_ngos"],
        },
        {
          path: "/ministry/ngos-communication",
          label: "إدارة المنظمات",
          icon: "GridIcon",
          slug: [
            "ministry_immediate_ngos",
            "ministry_ngos_validation",
            "ministry_ngos_validation_report",
            "ngo_messages",
            "ministry_incentives_management_comm",
            "ministry_accept_reject_campaigns_comm",
            "ministry_mediation_request",
            "ministry_financial_grants"
          ],
        },
        {
          path: "/ministry/accreditation-transactions",
          name: "ministry_transactions",
          label: "المعاملات",
          icon: "FileTextIcon",
          slug: ["ministry_transaction_requests"],
        },
        {
          path: "/ministry/ngos-data",
          label: "تقارير المنظمات",
          icon: "DatabaseIcon",
          
          slug: [
            "ministry_ngos_management",
            // "ministry_categories_management",
            // "ministry_services_management",
            "ministry_branches_management",
            // "ministry_opportunities_management",
            "ministry_service_centres_management",
            // "ministry_contact_information_management",
            "ministry_bank_accounts_management",
            "ministry_account_managers_management",
            "ministry_real-estates_management",
            "ministry_machines_management",
            // "ministry_administration_management",
            // "ministry_founders_management",
            // "ministry_trustees_board_management",
            // "ministry_executives_management",
            "ministry_employees_management",
            // "ministry_volunteers_management",
            "ministry_programs_management",
            "ministry_activities_management",
            // "ministry_plans_management",
            "ministry_campaigns_management",
            "ministry_job_opportunities_management",
            "ministry_job_opportunities_management",
            "ministry_volunteer_opportunities_management",
            // "ministry_events_management",
            "ministry_news_management",
            "ministry_advanced_reports",
          ],
        },
        // {
        //   path: "/ministry/creation-requests",
        //   label: "طلبات التأسيس",
        //   icon: "FileTextIcon",
        //   slug: ["ministry_establishment_ngos_requests"],
        // },
        {
          path: "/ministry/settings",
          label: "إعدادات",
          icon: "SettingsIcon",
          slug: [
            "ministry_Q&A",
            "ministry_question_categories",
            "ministry_indexes",
            "ministry_instructions",
            "ministry_annual_holidays",
            "ministry_events",
            "ministry_users_rp",
            "ministry_roles_rp",
            // "ministry_permissions_rp",
            "ministry_slider",
            "ministry_regulations",
            "ministry_users_availability",
            "ministry_transaction_types",
            "ministry_action_types"
          ],
        },
        {
          path: "/ministry/notifications",
          label: "الإشعارات",
          icon: "BellIcon",
          slug: ["ministry_notifications_managment"],
        },
      ],
    };
  },
  methods: {
    ...mapActions("User", ["fetchUserNotifications"]),
    checkIsHeaderGroup(item) {
      // console.log("item" , item)
      // console.log("item.every((el) => AuthHelpers.canNavigate(el))" , item.every((el) => AuthHelpers.canNavigate(el)))
      // console.log("item.some((el) => AuthHelpers.canNavigate(el))" , item.some((el) => AuthHelpers.canNavigate(el)))
      return item.some((el) => AuthHelpers.canNavigate(el));
    },
  },
  created() {
    // Set `appConfig` when page/SFC is created
    this.$store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", true);
    this.fetchUserNotifications(true);
  },
  beforeDestroy() {
    if (this.$store.hasModule("Ministry"))
      this.$store.unregisterModule("Ministry");
  },
  destroyed() {
    // Restore the state value of `appConfig` when page/SFC is destroyed
    this.$store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", this.menuHidden);
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.tab-cont {
  border-radius: 5px;
  padding: 20px 0px;
  color: var(--info);
  background-color: transparent;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.7;
  }
}

.router-link-exact-active,
.router-link-active {
  .tab-cont {
    color: white;
    background-color: var(--info);
  }
}

.steps-tabs {
  .nav-vertical .nav.nav-tabs .nav-item .nav-link.active::after {
    display: none;
  }

  .tab-content {
    border-left: 1px solid lightgray;
  }

  .nav-link {
    transition: all 0.2s ease;
  }

  .nav-link.active {
    background-color: var(--success);
    color: white;
    border-radius: 8px;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  }
}
</style>
